module.exports = __webpack_public_path__ + "media/components/helpcenter/InsightsHelp/InsightIncident1-0a35c032621dfb05c9a67ab1c7f566a4.jpg";